import { graphql, readInlineData } from 'react-relay';

import {
    trackingConstants,
    eventNameConstants,
    interactionTypeConstants,
    trackEvent,
    trackEcommerce,
    type EcomProduct,
} from 'dibs-tracking';

import { type estimateSimilarSoldTracking_item$key } from './__generated__/estimateSimilarSoldTracking_item.graphql';

const { EVENT_SELECT_ITEM, EVENT_VIEW_ITEM_LIST, EVENT_PRODUCT_INTERACTION } = eventNameConstants;
const { ECOM_PRODUCT_CLICK, ECOM_PRODUCT_IMPRESSION } = trackingConstants;
const { INTERACTION_TYPE_PDP } = interactionTypeConstants;

const ESTIMATE_SIMILAR_SOLD_ITEM = '1stDibs Estimate Similar Item';

const itemFragment = graphql`
    fragment estimateSimilarSoldTracking_item on Item @inline {
        browseUrl
        categoryCode
        ecommerceTrackingParams
        serviceId
    }
`;

const getEstimateSimilarSoldItemTrackingProduct = ({
    item: itemRef,
    itemIndex,
}: {
    item: estimateSimilarSoldTracking_item$key;
    itemIndex: number;
}): EcomProduct => {
    const item = readInlineData(itemFragment, itemRef);

    const { browseUrl, categoryCode, ecommerceTrackingParams } = item || {};

    return {
        position: itemIndex + 1,
        categoryCode,
        category: browseUrl,
        ...ecommerceTrackingParams,
    };
};

export const trackEstimateSimilarSoldItemClick = ({
    item: itemRef,
    itemIndex,
}: {
    item: estimateSimilarSoldTracking_item$key;
    itemIndex: number;
}): void => {
    const item = readInlineData(itemFragment, itemRef);

    trackEcommerce({
        type: ECOM_PRODUCT_CLICK,
        eventName: EVENT_SELECT_ITEM,
        trigger: ESTIMATE_SIMILAR_SOLD_ITEM,
        actionField: { list: ESTIMATE_SIMILAR_SOLD_ITEM, itemId: item?.serviceId },
        products: [getEstimateSimilarSoldItemTrackingProduct({ item: itemRef, itemIndex })],
    });
};

export const trackEstimateSimilarSoldItemImpression = ({
    item: itemRef,
    itemIndex,
}: {
    item: estimateSimilarSoldTracking_item$key;
    itemIndex: number;
}): void => {
    trackEcommerce({
        type: ECOM_PRODUCT_IMPRESSION,
        eventName: EVENT_VIEW_ITEM_LIST,
        trigger: ESTIMATE_SIMILAR_SOLD_ITEM,
        products: [
            {
                ...getEstimateSimilarSoldItemTrackingProduct({ item: itemRef, itemIndex }),
                list: ESTIMATE_SIMILAR_SOLD_ITEM,
            },
        ],
    });
};

export const trackEstimateSimilarSoldRangeClick = (): void => {
    trackEvent({
        eventName: EVENT_PRODUCT_INTERACTION,
        interaction_type: INTERACTION_TYPE_PDP,
        step_interaction_name: '1stdibs estimate clicked',
        trigger: '1stdibs estimate siderail',
        isInteractiveEvent: true,
    });
};
